import type { ReactNode } from "react";

import { maskConnectedAccountLabel } from "../../lib/connectedAccountEmail";
import type { ProviderAccountListItem } from "./ProviderAccountManagePanel";

interface ProviderAccordionSummaryProps {
  readonly account: ProviderAccountListItem | null;
  readonly fallback: ReactNode;
}

export function ProviderAccordionSummary({ account, fallback }: ProviderAccordionSummaryProps) {
  if (account === null) return fallback;

  const identity =
    account.accountDisplayName ??
    (account.accountEmail === null ? null : maskConnectedAccountLabel(account.accountEmail));
  const detail = [account.planLabel, account.needsReconnect ? "Reconnect required" : null]
    .filter((value): value is string => value !== null)
    .join(" · ");

  return (
    <p className="flex min-w-0 flex-wrap items-center gap-x-1 text-[13px] leading-[1.45] text-muted-foreground/80">
      <span>{identity === null ? "Default subscription" : "Authenticated as"}</span>
      {identity === null ? null : <span className="truncate text-foreground/80">{identity}</span>}
      {detail.length === 0 ? null : <span>· {detail}</span>}
    </p>
  );
}
